// removed by extract-text-webpack-plugin
module.exports = {"includeList":"_20fOhlHI6Dx_AIRe8Mh93H","includeItem":"_3xqqc3rln-OXIvAu7_LYOc","iconWrap":"_1eIw_CWwS8TRfXso2aiI1u","icon":"nZ5YRXFO7cxPxz0KVdrSH","iconBg":"VjP21a2Uk6eOoV3XF-vxt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModuleInclude/ModuleInclude.mod.css
// module id = 1629
// module chunks = 0